import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Component, Input, AfterViewInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
    selector: 'hub-iframe',
    templateUrl: './hub-iframe.component.html',
    animations: [
        trigger('visibilityChanged', [
            state('shown' , style({ opacity: 1 })),
            state('hidden', style({ opacity: 0 })),
            transition('shown => hidden', animate('600ms')),
            transition('hidden => shown', animate('300ms')),
        ]),
    ],
})
export class HubIframeComponent {

    @Input() public reload: boolean = false;

    public url: SafeResourceUrl;
    @Input() public isVisible: boolean = true;

    @Input() public set vimeoId(id: string) {
        this._vimeoId = id;

        if (this.reload) {
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.vimeoId);
        }
    }

    public get vimeoId() {
        return this._vimeoId;
    }

    public visibility = 'shown';
    // tslint:disable-next-line:variable-name
    private _vimeoId: string;

    constructor( private sanitizer: DomSanitizer ) {}

    public ngOnChanges() {
        this.visibility = this.isVisible ? 'shown' : 'hidden';
    }
}
